module.exports = __webpack_public_path__ + "media/images/document-8b7683ab.jpg";